import React, { useContext } from 'react';
import StepContext from 'components/wizard/context/step/context';

export const useStep = () => {
  return useContext(StepContext);
};
